// hooks/useResumeAnomalyTasks.ts
import { wsBaseUrl } from "@constants";
import { useEffect, useRef, useState } from "react";

interface TaskMeta {
  taskId: string;
  fileId: string;
  fileName: string;
  projectId: string;
  startedAt: number;
}

export const useResumeAnomalyTasks = (files: any[]) => {
  const [activeTaskFileIds, setActiveTaskFileIds] = useState<string[]>([]);
  const wsConnectedRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const tasksJson = localStorage.getItem("activeUploadTasks");
    if (!tasksJson) return;

    const tasks: TaskMeta[] = JSON.parse(tasksJson);
    const freshTasks = tasks.filter(
      (task) => Date.now() - task.startedAt < 10 * 60 * 1000
    );

    setActiveTaskFileIds(freshTasks.map((task) => task.fileId));

    freshTasks.forEach((task) => {
      if (wsConnectedRef.current.has(task.taskId)) return;
      if (task.taskId === "null" || task.taskId === "" || task.taskId === null)
        return;

      const ws = new WebSocket(`${wsBaseUrl}/task/${task.taskId}`);
      wsConnectedRef.current.add(task.taskId);

      ws.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.state === "SUCCESS") {
          const all = JSON.parse(
            localStorage.getItem("activeUploadTasks") || "[]"
          );
          const filtered = all.filter(
            (t: TaskMeta) => t.taskId !== task.taskId
          );
          localStorage.setItem("activeUploadTasks", JSON.stringify(filtered));

          setActiveTaskFileIds((prev) =>
            prev.filter((id) => id !== task.fileId)
          );
          wsConnectedRef.current.delete(task.taskId);
          ws.close();
        }
      };

      ws.onerror = () => {
        ws.close();
        wsConnectedRef.current.delete(task.taskId);
      };

      ws.onclose = () => {
        wsConnectedRef.current.delete(task.taskId);
      };
    });
  }, [files]);

  return activeTaskFileIds;
};
